import { render, staticRenderFns } from "./WizardListing.vue?vue&type=template&id=920e5aa2"
import script from "./WizardListing.vue?vue&type=script&lang=js"
export * from "./WizardListing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports